import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { fetchList } from "../api";
import { PageHero, Loader } from "../components/Shared";
import { NewsMedia } from "../components/NewsMedia";

const fmtDate = (d) => { try { return new Date(d).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" }); } catch { return ""; } };

export default function News() {
  const [news, setNews] = useState(null);
  useEffect(() => { fetchList("news").then(setNews).catch(() => setNews([])); }, []);
  if (!news) return <Loader />;

  const [featured, ...rest] = news;

  return (
    <div data-testid="news-page">
      <PageHero kicker="Latest" title="News" image="https://images.unsplash.com/photo-1657672825833-7b2ad6fae220?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000" />
      <section className="px-6 md:px-12 lg:px-20 pb-24">
        {featured && (
          <Link to={`/news/${featured.id}`} data-testid={`news-featured-${featured.id}`} className="grid grid-cols-1 lg:grid-cols-2 gap-8 group mb-16 border border-zinc-800 overflow-hidden">
            <div className="aspect-video lg:aspect-auto overflow-hidden">
              <NewsMedia src={featured.image} poster={featured.poster} alt={featured.title} className={`w-full h-full object-cover group-hover:scale-105 transition-transform duration-500 ${/tourney|lt763n1a|j2k9i302|4r42yp65|2twvtqsw|742511545/.test(featured.image) ? "object-[center_20%]" : ""}`} />
            </div>
            <div className="p-8 lg:p-12 flex flex-col justify-center">
              <span className="font-mono text-xs uppercase tracking-widest text-brand">{featured.category} · {fmtDate(featured.date)}</span>
              <h2 className="font-display text-4xl sm:text-5xl uppercase tracking-tight mt-3 leading-none group-hover:text-brand transition-colors">{featured.title}</h2>
              <p className="text-zinc-400 mt-4 leading-relaxed">{featured.excerpt}</p>
              <span className="font-display text-xl uppercase text-brand mt-6">Read Story →</span>
            </div>
          </Link>
        )}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {rest.map((n, i) => (
            <motion.div key={n.id} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: (i % 3) * 0.1 }}>
              <Link to={`/news/${n.id}`} data-testid={`news-card-${n.id}`} className="group block">
                <div className="aspect-video overflow-hidden border border-zinc-800 mb-4">
                  <NewsMedia src={n.image} poster={n.poster} alt={n.title} className={`w-full h-full object-cover group-hover:scale-105 transition-transform duration-500 ${/tourney|lt763n1a|j2k9i302|4r42yp65|2twvtqsw|742511545/.test(n.image) ? "object-[center_20%]" : ""}`} />
                </div>
                <span className="font-mono text-xs uppercase tracking-widest text-brand">{n.category} · {fmtDate(n.date)}</span>
                <h3 className="font-display text-2xl uppercase tracking-tight mt-2 group-hover:text-brand transition-colors leading-tight">{n.title}</h3>
                <p className="text-zinc-500 mt-2 line-clamp-2">{n.excerpt}</p>
              </Link>
            </motion.div>
          ))}
        </div>
      </section>
    </div>
  );
}
